import React from "react";
import { PricingPage as BillingPricingPage } from "@byscott-io/billingbyscott_client";

// Use the billing package's marketing PricingPage. It fetches the PUBLIC plan
// catalog via getPublicProducts() (billing api key only — no account/externalId),
// renders its own MarketingLayout, and falls back gracefully when no products are
// configured (metrics has none by design — plans/terms live in billing). Prerender
// (puppeteer/Chrome) executes this and captures whatever renders, so no static SEO
// data is needed. Do NOT use the raw <PlanSelector> here — that calls the
// authenticated getProducts() and throws "externalId not available" for anonymous
// visitors, which blanked/errored this page.
export default function PricingPage() {
  return (
    <BillingPricingPage
      hero={{
        headline: "Simple, Transparent Pricing",
        subheadline: "Choose the plan that fits your needs",
      }}
      pricing={{ showBillingToggle: false }}
      cta={{
        headline: "Ready to get started?",
        primaryCta: { label: "Get Started", href: "/register" },
        secondaryCta: { label: "Contact Us", href: "/contact" },
      }}
    />
  );
}
